import { combineReducers } from 'redux';

import { auth } from './auth/reducer';
import { generalIndicator } from './generalIndicators/reducer';
import { indicators } from './indicators/reducer';
import { careLines } from './careLines/reducer';
import { instituitions } from './instituitions/reducer';
import { users } from './users/reducer';
import { comunicado } from './comunicado/reducer';

export default combineReducers({
  auth,
  generalIndicator,
  indicators,
  careLines,
  instituitions,
  users,
  comunicado,
});
